import React, { useEffect } from 'react'
import { Box } from '@node-space/ui-components'
import { ContactsSheets } from 'pages/Contacts/components/ContactsSheets'
import { ContactAtomType } from 'types/atoms/atom.contacts'
import { PaymentLinkStep } from 'types/payments'
import { ContactsSearch } from '../../../components/Contacts/ContactsSearch'
import { usePaymentFlow } from '../hooks/usePaymentFlow'
import { paymentLinkStepAtom } from './atoms/atoms'
import { PaymentLinkComplete } from './PaymentLinkComplete'
import { PaymentLinkDetails } from './PaymentLinkDetails'

const paymentLinkSteps = [
  PaymentLinkStep.CONTACT,
  PaymentLinkStep.DETAILS,
  PaymentLinkStep.COMPLETE,
] as const

export const PaymentLink = () => {
  const { currentStep, isContactSheetOpen, updateWalletAction } = usePaymentFlow({
    stepAtom: paymentLinkStepAtom,
    steps: paymentLinkSteps,
    stepConfig: PaymentLinkStep,
    translationKeys: {
      contactStepHeader: 'payments.paymentLinks.contactStepHeader',
      detailsStepHeader: 'payments.paymentLinks.detailsStepHeader',
      requiredFieldsCallout: 'contacts.paymentLinkRequiredAdditionalContactDetails',
    },
  })

  useEffect(() => {
    updateWalletAction()
  }, [currentStep])

  return (
    <Box width="full">
      {currentStep === PaymentLinkStep.CONTACT && (
        <ContactsSearch atomType={ContactAtomType.WALLET_ACTION} />
      )}
      {currentStep === PaymentLinkStep.DETAILS && <PaymentLinkDetails />}
      {currentStep === PaymentLinkStep.COMPLETE && <PaymentLinkComplete />}
      <ContactsSheets isSheetOpen={isContactSheetOpen} isNestedSheet={true} />
    </Box>
  )
}
